export const shapes = {
  RB: 'Round',
  PR: 'Princess',
  SQCUS: 'Square Cushion',
  CUS: 'Cushion',
  EC: 'Emerald',
  AS: 'Asscher',
  SQR: 'Square Radiant',
  OV: 'Oval',
  RAD: 'Radiant',
  MQ: 'Marquise',
  PS: 'Pear',
  HS: 'Heart',
  TR: 'Trillian',
}

export const polsymm = {
  0: 'Poor',
  1: 'Fair',
  2: 'Good',
  3: 'Very Good',
  4: 'Excellent',
  5: 'Ideal',
}
